import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import img from '../../assets/images/items/img3.jpg'
// import { Link } from 'react-router-dom';
// import MenuIcon from '@rsuite/icons/Menu';
// import GridIcon from '@rsuite/icons/Grid';
// import { Icon } from '@rsuite/icons';
import {
  Button,
  Form,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  TagPicker,
  Container,
  Modal,
  Toggle,
  IconButton,
  Table,
  CellProps,
  Dropdown,
  Placeholder,
  Input,
  SelectPicker,
  FlexboxGrid,
  Col,
  Checkbox,
  Message,
  useToaster
} from 'rsuite';
import { Icon, Paragraph } from '@rsuite/icons';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import TrashIcon from '@rsuite/icons/Trash';
import CloseIcon from '@rsuite/icons/Close';
import { mockUsers } from '@/data/mock';
import SendIcon from '@rsuite/icons/Send';
import ProjectIcon from '@rsuite/icons/Project';
import CloseOutlineIcon from '@rsuite/icons/CloseOutline';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import { useLocation } from 'react-router-dom';


type YourDataType = {
  id: number;
  attributes: {
    CoverImage: any;
    ProductName: string;
    ProductId: string;
    ProductType: string;
    SizeUnit: string;
    Length: number;
    Width: number;
    Color: string;
    Finish: string;
    // Add other attribute properties here
  };
};
import TreemapIcon from '@rsuite/icons/Treemap';
import DrawerViewe from './DrawerViewe';


import DrawerLink from './DrawerLink';



export const ImageCell = ({ rowData, dataKey, ...props }: CellProps) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div
      style={{
        width: 40,
        height: 40,
        background: '#f5f5f5',
        borderRadius: 6,
        marginTop: 2,
        overflow: 'hidden',
        display: 'inline-block'
      }}
    >
      <img src={rowData[dataKey!]} width="40" />
    </div>
  </Cell>
);


const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
    const editing = rowData.status === 'EDIT';
    if (dataKey === "ProductType" || dataKey === "category" || dataKey === "unit" || dataKey === "Color"|| dataKey === "Finish" ) {
      return (
        <Cell {...props} className={editing ? "table-content-editing" : ""}>
          {editing ? (
            <span className="table-content-edit-span">{rowData[dataKey]}</span>
          ) : (
            <SelectPicker
              defaultValue={rowData[dataKey]}
              onChange={event => {
                onChange && onChange(rowData.id, dataKey, event.target.value);
              } } data={[]}        />
          )}
        </Cell>
      );
    }else if(dataKey === "id" || dataKey === "CBM" ){
      return (
        <Cell {...props} className={editing ? 'table-content-editing' : ''}>
          {editing ? (
            <span className="table-content-edit-span">{rowData[dataKey]}</span>
          ) : (
            <input
              className="rs-input"
              readOnly
              defaultValue={rowData[dataKey]}
              onChange={event => {
                onChange && onChange(rowData.id, dataKey, event.target.value);
              }}
            />
          )}
        </Cell>
      );
    }else{
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        ) : (
          <input
            className="rs-input"
            defaultValue={rowData[dataKey]}
            onChange={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        )}
      </Cell>
    );
  };
}
  
  const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
    return (
      <Cell {...props} style={{ padding: '6px' }}>
        <Button
          appearance="default"
          active
          onClick={() => {
            onClick(rowData.id);
          }}
        >
          {rowData.status === 'EDIT' ? <Icon as={CheckIcon} /> : <Icon as={EditIcon} />}
        </Button>
      </Cell>
    );
  };
  



const { Column, HeaderCell, Cell } = Table;


const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
const ip = 'http://192.168.1.83:1337';
const defaultColumns = [
  {
    key: 'id',
    label: <b>ID</b>,
    fixed: true,
    width: 60
  },
  {
    key: 'Image',
    label: 'Image',
    width: 150,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Image</b></Table.HeaderCell>,
    cell: <Table.Cell >{(rowData) => (
      <img
        src={`${ip}${rowData.attributes.CoverImage.data.attributes.url}`}
        alt="User Image"
        style={{ width: 50, height: 50, marginTop: '-16px' }}
      />
    )}</Table.Cell>
  },
  {
    key: 'ProductType',
    label: 'Product Type',
    width: 150,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Product Type</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.ProductType" />
  },
  {
    key: 'category',
    label: 'Carton Type',
    width: 100,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Carton Type</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.CartonType"/>
  },
  {
    key: 'unit',
    label: 'Size Unit',
    width: 150,
    headerCell: <Table.HeaderCell flexGrow={1}><b>SizeUnit</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.SizeUnit" />
  },
  {
    key: 'length',
    label: 'Length',
    width: 100,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Length</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.Length" />
  },
  {
    key: 'width',
    label: 'Width',
    width: 100,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Width</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.Width" />
  },
  {
    key: 'height',
    label: 'Height',
    width: 100,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Height</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.Height" />
  },
  {
    key: 'Color',
    label: 'Color',
    width: 150,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Color</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.Color" />
  },
  {
    key: 'Finish',
    label: 'Finish',
    width: 100,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Finish</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.Finish"/>
  },
  {
    key: 'ProductCost',
    label: 'Product Cost',
    width: 100,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Product Cost</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.ProductCost" />
  },
  {
    key: 'CBM',
    label: 'CBM',
    width: 100,
    headerCell: <Table.HeaderCell flexGrow={1}><b>CBM</b></Table.HeaderCell>,
    cell: <Table.Cell dataKey="attributes.CBM" />
  },
  {
    key: 'Action',
    label: 'Action',
    width: 100,
    headerCell: <Table.HeaderCell flexGrow={1}><b>Action</b></Table.HeaderCell>,
    cell: <Table.Cell style={{ padding: '6px' }}>
      <IconButton
        size="sm"
        icon={<TrashIcon />}
        active
        disabled
        // onClick={() => handleDeleteRow(rowData.id)}
      />
    </Table.Cell>
  }

];

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

interface MetaData {
  pagination: PaginationData;
}


const EditDetails = () => {

  const [placement, setPlacement] = React.useState('topEnd');
  const toaster = useToaster();
  const message = (
    <Message showIcon type='success' closable>
      Catalogue Generate successfully.
    </Message>
  );


  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () =>{ 
    setOpen1(false);
    toaster.push(message, { placement })
  }
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    setOpen2(false); 
    toaster.push(message, { placement:'topEnd' })
  }

  

    const [showDrawer2, setShowDrawer2] = useState(false);
    const [showDrawer3, setShowDrawer3] = useState(false);
        

  const [compact, setCompact] = React.useState(true);
  const [noData, setNoData] = React.useState(false);
  const [autoHeight, setAutoHeight] = React.useState(true);
  const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key).filter(key => key !== 'ProductCost'));

  const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;

  // Fetch Data from API Start
  const [meta123, setMeta123] = useState<MetaData>();
  const [data123, setData123] = useState<YourDataType[]>([]);
  const [editingRowId, setEditingRowId] = useState<number | null>(null);
  const [editedData, setEditedData] = useState<Partial<YourDataType>>({} as Partial<YourDataType>);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch('http://192.168.1.83:1337/api/products?populate=*');
    const json = await response.json();
    setData123(json.data);
    setMeta123(json.meta);
  };
  //  Fetch Data from API End

  // Delete Data from API Start
  const handleDeleteRow = async (rowId: number) => {
    try {
      const response = await fetch(`http://192.168.1.83:1337/api/products/${rowId}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        const updatedData = data123.filter((row) => row.id !== rowId);
        setData123(updatedData);
        console.log('Row deleted successfully.');
      } else {
        console.log('Failed to delete row.');
      }
    } catch (error) {
      console.error('Error deleting row:', error);
    }
  };
  // Fetch Data from API End

  const ip = 'http://192.168.1.83:1337';
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const selectedItemsArray = selectedItems.split(',');

  // Filter the data based on the selected items
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(data123.filter((item) => selectedItemsArray.includes(String(item.id))));
  }, [data123, selectedItemsArray]);

  const [selectedItemsToAdd, setSelectedItemsToAdd] = useState([]);
  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItemsToAdd((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItemsToAdd((prevSelectedItems) => prevSelectedItems.filter((item) => item !== value));
    }
  };

  const handleSelectAll = (value, checked) => {
    if (checked) {
      const allItemIds = data123.map((item) => String(item.id));
      setSelectedItemsToAdd(allItemIds);
    } else {
      setSelectedItemsToAdd([]);
    }
  };

  const handleAddItems = () => {
  //   const newFilteredData = data123.filter(item => selectedItems.includes(String(item.id)));
  // setFilteredData(newFilteredData);
   
  const newFilteredData = [
    ...filteredData,
    ...data123.filter((item) => selectedItemsToAdd.includes(String(item.id))),
  ];
  setFilteredData(newFilteredData);
    // Close the modal or show a success message
    handleClose2();
  };


  const handleToggleChange = checked => {
    if (checked) {
      // Show the 'ProductCost' column
      setColumnKeys(prevColumnKeys => [...prevColumnKeys, 'ProductCost']);
    } else {
      // Hide the 'ProductCost' column
      setColumnKeys(prevColumnKeys => prevColumnKeys.filter(key => key !== 'ProductCost'));
    }
  };


      // const handleChange = (id, key, value) => {
      //   const nextData = Object.assign([], data);
      //   nextData.find(item => item.id === id)[key] = value;
      //   setData(nextData);
      // };
      // const handleEditState = id => {
      //   const nextData = Object.assign([], data);
      //   const activeItem = nextData.find(item => item.id === id);
      //   activeItem.status = activeItem.status ? null : 'EDIT';
      //   setData(nextData);
      // };
      
    
  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start'>
              <h3 className="title">Catalogues</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/catalogue">Create Catalogue</Breadcrumb.Item>
                <Breadcrumb.Item href="/selection">Select Product</Breadcrumb.Item>
                <Breadcrumb.Item active>Edit Details</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            
            
          </Stack>

          <Stack direction='column' alignItems='flex-end' spacing={53}>
            <Stack direction='row' spacing={5}>
              {/* <InputGroup inside >
                <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button> */}
            </Stack>

            {/* <div>
        <h6>Selected Items:</h6>
        <ul>
          {selectedItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div> */}
            <Stack spacing={10}>
              <label>Show Product Cost: </label>
              <Toggle checked={columnKeys.includes('ProductCost')} onChange={handleToggleChange}  />
              <Button appearance="subtle" active onClick={handleOpen2}>
                Add More Product
                </Button>
              <Button appearance="ghost" color='cyan' onClick={handleOpen}>
                Customize Table
              </Button>
              <Dropdown title="Create" placement="bottomEnd" color='cyan' appearance='primary'>
                    <Dropdown.Item ><Stack spacing={30}><Stack direction='column' alignItems='flex-start'><b>Collection</b><p>Get this catalouge approve by admin</p></Stack><Stack><Icon as={TreemapIcon}/></Stack></Stack></Dropdown.Item>
                    <Dropdown.Item onClick={handleOpen1}><Stack spacing={80}><Stack direction='column' alignItems='flex-start'><b>Catalogue Draft</b><p>Create catalogue for a buyer</p></Stack><Stack><Icon as={ProjectIcon}/></Stack></Stack></Dropdown.Item>
                    <Dropdown.Item ><Stack spacing={145}><Stack direction='column' alignItems='flex-start'><b>Catalogue Publish</b><p>Publish catalogue</p></Stack><Stack><Icon as={SendIcon}/></Stack></Stack></Dropdown.Item>
                </Dropdown>
              {/* <Button color="cyan" appearance="primary">
                Continue
            </Button> */}
            </Stack>
          </Stack>

        </Stack>
        
          <b style={{ marginLeft: '20px' }}>{filteredData.length} Products</b>
        
        <Divider className='divide' />
        <div className="row">

          <Panel>
            <Table
              rowHeight={60}
              data={noData ? [] : filteredData}
              height={400}
              rowKey="id"
            >
              {defaultColumns.map(column => {
                if (columnKeys.includes(column.key)) {
                  const { key, label, headerCell, cell, ...rest } = column;
                  return (
                    <Table.Column {...rest} key={key}>
                      {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                      {cell || <CustomCell dataKey={key} />}
                    </Table.Column>
                  );
                }
                return null;
              })}
            </Table>
          </Panel>
        </div>
        <Modal open={open} onClose={handleClose} backdrop={'static'}>
          <Modal.Header>
            <Modal.Title><h3 className="title">Customize Details</h3></Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <TagPicker
              data={defaultColumns}
              labelKey="label"
              valueKey="key"
              value={columnKeys}
              onChange={setColumnKeys}
              cleanable={false}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} appearance="primary" color='cyan'>
              Done
            </Button>

          </Modal.Footer>
        </Modal>
        <Modal open={open1} onClose={handleClose1} backdrop={'static'} size="lg">
          <Modal.Header>
            <Modal.Title><h3 className="title">Confirm all Details</h3></Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form fluid>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Catalogue name</Form.ControlLabel>
                <Form.Control name="name" />
              </Form.Group>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                    <Form.Control name="name" />
                  </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Form.Group controlId="email-1" >
                    <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                    <Form.Control name="name" type="email" />
                  </Form.Group>
                  </FlexboxGrid.Item>
    
                <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{marginTop:20}}>
                  <Panel bordered>
                    <Stack justifyContent='space-between'>
                      <b>Presentation template</b>
                      <Button appearance="ghost" color='cyan' onClick={()=> setShowDrawer3(true)}>
                        Update
                      </Button>
                    </Stack>
                    <Stack direction='column' alignItems='flex-start'>
                      <label>Default template selected</label>
                      <img src={img} className='imgp' />
                      <label>Template Design for your requirement</label>
                    </Stack>
                  </Panel>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{marginTop:20}}>
                  <Panel bordered>
                    <Stack justifyContent='space-between'>
                      <b>Link Settings</b>
                      <Button onClick={()=> setShowDrawer2(true)} appearance="ghost" color='cyan'>
                        Update
                      </Button>
                    </Stack>
                    <Stack direction='column' alignItems='flex-start'>
                      <label>Recommended</label>
                      <Stack direction='row' spacing={10}>
                        <Icon as={CloseOutlineIcon}></Icon><label>Email ID in NOT require to view catalogue</label>
                      </Stack>
                      <Stack direction='row' spacing={10}>
                        <Icon as={CheckOutlineIcon}></Icon><label>You can download PPT</label>
                      </Stack>
                      <Stack direction='row' spacing={10}>
                        <Icon as={CloseOutlineIcon}></Icon><label>You Cannot see filters on catalouge</label>
                      </Stack>
                    </Stack>
                  </Panel>
                </FlexboxGrid.Item>

              
            </Form>

          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent='space-between' >
              <Button onClick={handleClose1} appearance="ghost" color='cyan'>
                Preview
              </Button>
              <Button onClick={handleClose1} appearance="primary" color='cyan'>
                Generate Cataloge
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>

        <Modal open={open2} onClose={handleClose2} backdrop={'static'} size='full'>
          <Modal.Header>
            <Modal.Title><h4 className="title">Add More Products</h4></Modal.Title>
          </Modal.Header>

          <Modal.Body>
          <Checkbox
            checked={selectedItemsToAdd.length === data123.length}
            indeterminate={selectedItemsToAdd.length > 0 && selectedItemsToAdd.length < data123.length}
            onChange={handleSelectAll}
          >
              Select All
            </Checkbox>

            <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>
              {data123.map((item) => (
                <FlexboxGrid.Item as={Col} colspan={24} md={6} key={item.id}>
                  <Panel className="box" bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Stack>
                    <Checkbox
                      value={item.id}
                      checked={selectedItemsToAdd.includes(item.id)}
                      onChange={(value, checked) => handleCheckboxChange(value, checked)}
                    />
                    </Stack>
                    <img src={`${ip}${item.attributes.CoverImage.data.attributes.url}`} className="imgp" />
                    <Panel>
                      <b>Product Name: {item.attributes.ProductName}</b>
                      <p>Alias Code: {item.attributes.ProductId}</p>
                    </Panel>
                  </Panel>
                </FlexboxGrid.Item>
              ))}
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleAddItems}
              appearance="primary"
              color="cyan"
              disabled={selectedItemsToAdd.length === 0}
            >
              Done
            </Button>

          </Modal.Footer>
        </Modal>


        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
        <DrawerViewe open={showDrawer3} onClose={() => setShowDrawer3(false)} />
        <DrawerLink open={showDrawer2} onClose={() => setShowDrawer2(false)} />
      </Container>
    </>
      
  );
};

export default EditDetails;